import React, {Component} from "react";
import {connect} from "react-redux";
import {Translate} from "react-i18nify";

import * as navigationActions from "../../../../actions/navigationActions";
import * as settingsActions from "../../../../actions/settingsActions";
import * as rccActions from "../../../../actions/rccActions";
import * as componentTypes from "../../../../constants/componentTypes";
import * as resources from "../../../../constants/resources";
import * as validationHelper from "../../../../helpers/validationHelper";
import * as rcc from "../../../../constants/rcc";
import * as formatHelper from "../../../../helpers/formatHelper";
import * as modelHelper from "../../../../helpers/modelHelper";

import imgRecirculate from "../../../../resources/img/svgicons/recirculate.svg";
import Modal from "../../../global/generic/Modal";
import Input from "../../../global/generic/Input";
import Button from "../../../global/generic/Button";
import CancelButton from "../../../global/generic/CancelButton";

class RecirculateAllChannelsModal extends Component {
    constructor(props) {
        super(props);

        this.state = {
            recirculatingTime: this.props.recirculatingTime,
            recirculatingSpeed: this.props.recirculatingSpeed
        };
    }

    handleCloseModalClick = () => {
        this.props.dispatchCloseModalAction();
    };

    handleStartRecirculatingClick = () => {
        this.props.dispatchRecirculateAllChannelsAction(
            Number(this.state.recirculatingTime),
            Number(this.state.recirculatingSpeed)
        );
    };

    handleRecirculatingTimeFocus = (event) => {
        event.target.select();
    };

    handleRecirculatingTimeChange = (event) => {
        if (validationHelper.isDecimalValueValid(event.target.value)) {
            this.setState({
                recirculatingTime: validationHelper.formatDecimal(event.target.value)
            });
        }
    };

    handleRecirculatingTimeBlur = (event) => {
        let value = Number(event.target.value);

        if (!isNaN(value) && value >= rcc.RCC_MINIMAL_RECIRCULATE_TIME) {
            this.setState({recirculatingTime: formatHelper.formatDecimal(value)});
            this.props.dispatchSetRecirculationTimeAction(parseInt(formatHelper.formatDecimal(value)));
        } else {
            this.setState({recirculatingTime: rcc.RCC_MINIMAL_RECIRCULATE_TIME});
            this.props.dispatchSetRecirculationTimeAction(rcc.RCC_MINIMAL_RECIRCULATE_TIME);
        }
    };

    handleRecirculatingSpeedFocus = (event) => {
        event.target.select();
    };

    handleRecirculatingSpeedChange = (event) => {
        if (validationHelper.isDecimalValueValid(event.target.value)) {
            this.setState({
                recirculatingSpeed: validationHelper.formatDecimal(event.target.value)
            });
        }
    };

    handleRecirculatingSpeedBlur = (event) => {
        let value = Number(event.target.value);

        if (!isNaN(value) && value <= 100 && value >= 1) {
            this.setState({recirculatingSpeed: formatHelper.formatDecimal(value)});
            this.props.dispatchSetRecirculationSpeedAction(parseInt(formatHelper.formatDecimal(value)));
        } else {
            this.setState({recirculatingSpeed: this.props.recirculatingSpeed});
        }
    };

    getContent = () => {
        return modelHelper.buildModalSection(
            <React.Fragment>
                <div className="col-6 flex flex-align-center-vertical">
                    <Translate className="padding-right-5" value="recirculateChannels.recirculatingTime" />
                    <Input
                        className="primary-input col-5"
                        value={this.state.recirculatingTime}
                        onFocus={this.handleRecirculatingTimeFocus}
                        onChange={this.handleRecirculatingTimeChange}
                        onBlur={this.handleRecirculatingTimeBlur}
                        disabled={this.props.loggedUser.canNotEdit(resources.SETTINGS_RECIRCULATION_TIME)}
                        labelAfter="s"
                    />
                </div>
                <div className="col-6 flex flex-align-center-vertical flex-end">
                    <Translate className="padding-right-5" value="recirculateChannels.recirculatingSpeed" />
                    <Input
                        className="primary-input col-5"
                        value={this.state.recirculatingSpeed}
                        onFocus={this.handleRecirculatingSpeedFocus}
                        onChange={this.handleRecirculatingSpeedChange}
                        onBlur={this.handleRecirculatingSpeedBlur}
                        disabled={this.props.loggedUser.canNotEdit(resources.SETTINGS_RECIRCULATION_SPEED)}
                        labelAfter="%"
                    />
                </div>
            </React.Fragment>
        );
    };

    getFooter = () => {
        return modelHelper.buildModalSection(
            <React.Fragment>
                <Button
                    svgBefore={imgRecirculate}
                    label={<Translate value="machineSettings.recirculateAll" />}
                    onClick={this.handleStartRecirculatingClick}
                    disabled={Number(this.state.recirculatingTime) <= 0 || Number(this.state.recirculatingSpeed) <= 0}
                />
                <CancelButton onClick={this.handleCloseModalClick} />
            </React.Fragment>
        );
    };

    render() {
        return (
            <Modal
                onClose={this.handleCloseModalClick}
                header={modelHelper.buildModalSection(<Translate value="recirculateChannels.recirculateAllChannels" />)}
                content={this.getContent()}
                footer={this.getFooter()}
                styles={{minWidth: "40%"}}
            />
        );
    }
}

const mapStoreToProps = (store) => {
    return {
        recirculatingSpeed: store.settings.recirculationSpeed,
        recirculatingTime: store.settings.recirculationTime,
        loggedUser: store.login.loggedUser
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        dispatchCloseModalAction: () => {
            dispatch(navigationActions.closeModal(componentTypes.RECIRCULATE_ALL_CHANNELS_MODAL));
        },
        dispatchRecirculateAllChannelsAction: (time, speed) => {
            dispatch(rccActions.recirculateAllChannels(time, speed));
        },
        dispatchSetRecirculationTimeAction: (recirculationTime) => {
            dispatch(settingsActions.setRecirculationTime(recirculationTime));
        },
        dispatchSetRecirculationSpeedAction: (recirculationSpeed) => {
            dispatch(settingsActions.setRecirculationSpeed(recirculationSpeed));
        }
    };
};

export default RecirculateAllChannelsModal = connect(mapStoreToProps, mapDispatchToProps)(RecirculateAllChannelsModal);
